// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "3ddf980e6-dirty",
    "hash": "3ddf980e6",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3ddf980e6-dirty",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
